import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    staking: 'Staking',
    defi: 'Defi',
    analytics: 'Analytics',
  },
};
